import { TerritoryPenaltyStatus } from '@/config/types';
import showError from '@/handler/error';
import { apiConfig } from '../api-config';

export default async function (id: string) {
  return apiConfig
    .get(`api/territory/penalty-status/${id}`)
    .then((response) => response.data as TerritoryPenaltyStatus)
    .catch((error) => {
      showError(error);
      return {} as TerritoryPenaltyStatus;
    });
}
